import BenchlingConfig from 'BenchlingConfig';

export default function isParameterOptimizationEnabled(): boolean {
  return BenchlingConfig.MACHINE_LEARNING_ENABLE_PARAMETER_OPTIMIZATION;
}

export function isParameterOptimizationExploratoryDataAnalysisEnabled(): boolean {
  return BenchlingConfig.MACHINE_LEARNING_ENABLE_PARAMETER_OPTIMIZATION_EXPLORATORY_DATA_ANALYSIS;
}
